var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-timeline',{attrs:{"data":_vm.timeline,"prefix":"view_member.block.timeline.types."}})}
var staticRenderFns = []

export { render, staticRenderFns }